import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-fdes-thermal-card',
  templateUrl: './fdes-thermal-card.component.html',
  styleUrls: ['./fdes-thermal-card.component.scss']
})
export class FdesThermalCardComponent {
  @Input() title?: string;
  @Input() conso = '284';
  @Input() consoUnit = 'MJ/t';
  @Input() elec = 12;
  @Input() gnr = 23;
  @Input() comb = 65;
  // One row per used combustible : name, mix share (%) and emission factor.
  @Input() combustibles: { label?: string; usagePct?: number; environmentalFactor?: number }[] = [];
  @Input() feUnit = 'kgCO2e/MJ';

  // Round a number (or numeric string) to `decimals`, keeping a dot separator (locale-independent —
  // the app registers the fr locale, so the number pipe would render a comma).
  fmt(v: number | string, decimals = 1): string {
    const n = typeof v === 'number' ? v : parseFloat(String(v).replace(',', '.'));
    if (!isFinite(n)) return v == null ? '' : String(v);
    const f = Math.pow(10, decimals);
    return (Math.round(n * f) / f).toString();
  }
}
